var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-agent-worktime" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon work-icon" },
              [_c("md-icon", [_vm._v("calendar_today")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("report.agentWorkTimeCalendar"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.agentWorkTimeDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("WorkTimeCalendar", {
                attrs: {
                  title: _vm.$t("report.agentWorkTimeCalendar"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon break-icon" },
              [_c("md-icon", [_vm._v("free_breakfast")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.agentBreakTime")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.agentBreakTimeDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("BreakCount", {
                attrs: {
                  title: _vm.$t("report.agentBreakTime"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }